module.exports = __webpack_public_path__ + "img/20.7.Chla.41a1bb55.png";